import { Box, Stack, styled, Tab, Typography } from "@mui/material";

export const ReactionTabsContainer = styled(Box)({
    borderBottom: 1,
    borderColor: "divider",
    width: "100%",
});

export const LoadingStack = styled(Stack)({
    margin: "0 16px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
});

export const ReactionTab = styled(Tab)({
    flexDirection: "row",
    fontSize: "14px",
    gap: "8px",
    padding: "0 8px",
    textTransform: "none",
    minHeight: "48px",

    "&.Mui-selected > *": {
        fontWeight: "500 !important",
    },
});

export const ReactedTabPanel = styled(Box)({
    padding: "0 16px",
});

export const ReactedUsersTabPanel = styled(ReactedTabPanel)({
    minHeight: "50vh", // for swiping small lists
});

export const ReactedUserItem = styled(Box)({
    display: "flex",
    alignItems: "center",
    gap: "16px",
    marginBottom: "16px",
    position: "relative",
});

export const ReactedUserName = styled(Typography)({
    fontSize: "16px",
    fontWeight: "500",
});

export const ReactionTypeTypography = styled(Typography)({
    fontSize: "14px !important",
    fontWeight: "400",
    color: "var(--community-color-primary-text) !important",
});

export const ReactedUserReaction = styled(Box)({
    position: "absolute",
    bottom: "-4px",
    left: "25px",
});
